export const environment = {
  name: 'staging',
  apiUrl: 'https://indaleti-api-staging-205565968697.africa-south1.run.app',
  /** Public marketing site (referral pages, programme terms). Staging has no separate site. */
  publicSiteUrl: 'https://indaleti.co.za',
};
